var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "quote-header fixed-grid has-4-cols-desktop has-1-cols-mobile",
    },
    [
      _c(
        "div",
        { staticClass: "grid" },
        [
          _vm.innerVehicle
            ? _c("quote-vehicle", {
                attrs: {
                  quote: _vm.innerValue,
                  "is-saving": _vm.headerSavingPanels.vehicle,
                  insurer: _vm.innerInsurer,
                },
                on: {
                  "update:quote": function ($event) {
                    _vm.innerValue = $event
                  },
                  updateQuoteItemsDefaultPaintGroup: (newVal, oldVal) =>
                    _vm.$emit(
                      "updateQuoteItemsDefaultPaintGroup",
                      newVal,
                      oldVal
                    ),
                  "select-vehicle": _vm.selectVehicle,
                  "component-blur": function ($event) {
                    return _vm.$emit("vehicle-component-blur")
                  },
                },
                model: {
                  value: _vm.innerVehicle,
                  callback: function ($$v) {
                    _vm.innerVehicle = $$v
                  },
                  expression: "innerVehicle",
                },
              })
            : _vm._e(),
          _vm.innerCustomer
            ? _c("quote-customer", {
                attrs: {
                  quote: _vm.innerValue,
                  "is-saving": _vm.headerSavingPanels.customer,
                  "is-new-customer-prompt": _vm.isNewCustomerPrompt,
                },
                on: {
                  "update:quote": function ($event) {
                    _vm.innerValue = $event
                  },
                  "select-customer": _vm.selectCustomer,
                  "component-blur": function ($event) {
                    return _vm.$emit("customer-component-blur")
                  },
                },
                model: {
                  value: _vm.innerCustomer,
                  callback: function ($$v) {
                    _vm.innerCustomer = $$v
                  },
                  expression: "innerCustomer",
                },
              })
            : _vm._e(),
          _vm.innerInsurer
            ? _c("quote-insurer", {
                attrs: {
                  quote: _vm.innerValue,
                  "is-saving": _vm.headerSavingPanels.insurer,
                  vehicle: _vm.innerVehicle,
                  "next-line-number": _vm.nextLineNumber,
                },
                on: {
                  "update:quote": function ($event) {
                    _vm.innerValue = $event
                  },
                  "select-insurer": _vm.selectInsurer,
                  "component-blur": function ($event) {
                    return _vm.$emit("insurer-component-blur")
                  },
                },
                model: {
                  value: _vm.innerInsurer,
                  callback: function ($$v) {
                    _vm.innerInsurer = $$v
                  },
                  expression: "innerInsurer",
                },
              })
            : _vm._e(),
          _c("quote-booking", {
            attrs: {
              "is-saving": _vm.headerSavingPanels.booking,
              quote: _vm.innerValue,
              insurer: _vm.innerInsurer,
            },
            on: {
              "update:quote": function ($event) {
                _vm.innerValue = $event
              },
              "component-blur": function ($event) {
                return _vm.$emit("booking-component-blur")
              },
            },
            model: {
              value: _vm.innerQuoteCycleTime,
              callback: function ($$v) {
                _vm.innerQuoteCycleTime = $$v
              },
              expression: "innerQuoteCycleTime",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }